function catalogTabsSliders() {
    let SlidersArray = []
    $(".shoe-tabs").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        SlidersArray[index] = new Swiper(`.shoe-tabs[data-slider-id="${index}"] .swiper-container`, {
            slidesPerView: "auto",
            spaceBetween: 0,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            loop: true,
            direction: 'vertical',
            navigation: {
                nextEl: `.shoe-tabs[data-slider-id="${index}"] .swiper-button-next`,
                prevEl: `.shoe-tabs[data-slider-id="${index}"] .swiper-button-prev`,
            },
        })

        let slidesCount = $(el).find(".swiper-slide:not(.swiper-slide-duplicate)").length
        if(slidesCount < 5){
            $(el).addClass("_remove-arrows")
        } else{
            $(el).removeClass("_remove-arrows")
        }
    })
}

catalogTabsSliders()
